import React from "react";
import { useNavigate } from "react-router-dom";
import { MoveLeft } from "lucide-react";
import LoginCodeInput from "../authentication/components/LoginCodeInput";
import "./JoinWithCode.css";
import styles from "../teams/components/TeamSettings.module.css";
import { useJoinWithCodeFlow, normalizeJoinEmail } from "./useJoinWithCodeFlow";

export default function JoinWithCode() {
  const navigate = useNavigate();
  const {
    joinCode,
    setJoinCode,
    emailInput,
    setEmailInput,
    error,
    setError,
    step,
    isValidating,
    isLoading,
    isOnline,
    handleContinue,
    handleCodeVerified,
    handleBackToForm,
  } = useJoinWithCodeFlow();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <div className="settings-element-header">
        <MoveLeft
          onClick={() => navigate("/app/demo-team/next")}
          className={styles["back-button"]}
          aria-label="Back"
        />
        <div className={styles["team-settings-header-spacer"]} aria-hidden />
      </div>
      {step === "code" && (
        <div style={{ padding: "16px", flex: 1 }}>
          {error && <div className="JoinWithCode-error">{error}</div>}
          <LoginCodeInput
            email={normalizeJoinEmail(emailInput)}
            onCodeVerified={handleCodeVerified}
            onBack={handleBackToForm}
            isLoading={isLoading}
            isOnline={isOnline}
            fullPage={false}
          />
        </div>
      )}
      {step !== "code" && (
        <>
          <div style={{ padding: "0 16px 16px" }}>
            <p style={{ margin: "0 0 12px", fontSize: "14px", color: "#555" }}>
              Enter your team code and email. We&apos;ll send a login code to
              your email — same as signing in.
            </p>

            {error && <div className="JoinWithCode-error">{error}</div>}

            <input
              type="email"
              autoComplete="email"
              className="JoinWithCode-input"
              value={emailInput}
              onChange={(e) => {
                setEmailInput(e.target.value);
                if (error) setError("");
              }}
              placeholder="Your email"
            />
            <input
              type="text"
              className="JoinWithCode-input"
              value={joinCode}
              onChange={(e) => {
                setJoinCode(e.target.value);
                if (error) setError("");
              }}
              placeholder="Enter your join code"
              autoComplete="off"
            />
            <button
              type="button"
              onClick={handleContinue}
              className="proceed-button"
              disabled={isValidating || !isOnline}
            >
              {!isOnline
                ? "Offline"
                : isValidating
                  ? "Checking…"
                  : "Send login code"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
